import MessageApi from '../../../../api/inbox/message';
import types from '../../../mutation-types';

// BonBoZ: dịch đang chạy cho (hội thoại, tin, ngôn ngữ) nào — guard nằm Ở ĐÂY
// chứ không trong component: mọi lối bấm dịch (menu của tin nào cũng vậy) đều
// đi qua action này, một chỗ chặn là đủ và không phụ thuộc vòng đời component.
const dangDich = new Set();

// Giá trị đặc biệt báo "lệnh dịch y hệt đang chạy rồi" — khác với null
// ("dịch thất bại") để component hiện đúng thông báo.
export const KET_QUA_DANG_DICH = 'BONBOZ_DANG_DICH';

export default {
  // BonBoZ: TRA VE noi dung da dich, va GHI THANG vao tin trong store.
  //
  // Truoc day ket qua chi den qua duong ActionCable (server update! -> event
  // -> websocket). Duong do co the cham hoac truot, va khi truot thi nguoi
  // truc bam Dich xong khong thay gi ca — dung trieu chung "co ban dich vi
  // roi, bam dich tieng Anh khong thay ket qua". Ghi thang tu phan hoi API
  // thi ket qua hien ngay khi LLM tra loi, websocket den sau cung khong sao
  // (ADD_MESSAGE thay theo id, cung noi dung).
  async translateMessage(
    { commit, getters },
    { conversationId, messageId, targetLanguage }
  ) {
    const khoa = `${conversationId}:${messageId}:${targetLanguage}`;
    if (dangDich.has(khoa)) return KET_QUA_DANG_DICH;

    dangDich.add(khoa);
    try {
      const { data } = await MessageApi.translateMessage(
        conversationId,
        messageId,
        targetLanguage
      );
      const noiDung = data?.content ?? null;
      if (noiDung) {
        const chat = getters.getConversationById(conversationId);
        const tin = chat?.messages?.find(m => m.id === messageId);
        if (tin) {
          // Store giu snake_case; chi luc render moi camelCase.
          const thuocTinh = { ...(tin.content_attributes || {}) };
          thuocTinh.translations = {
            ...(thuocTinh.translations || {}),
            [targetLanguage]: noiDung,
          };
          thuocTinh.bonboz_dich_hien = targetLanguage;
          commit(types.ADD_MESSAGE, { ...tin, content_attributes: thuocTinh });
        }
      }
      return noiDung;
    } finally {
      dangDich.delete(khoa);
    }
  },
};
